import React, { useEffect,useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PageBanner from '../ui/PageBanner';
import careerImage from '../assets/Careers/careers.jpg';
import CareerBannerImage from '../assets/Careers/CareerBanner.jpg';
import Preloader from '../ui/Preloader';

const Careers = () => {
  const [ loading, setLoading ] = useState(true);
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(delay);
  }, []);

  return (
    <>
    {loading ? (
      <Preloader />
    ) : (
      <div className="font-roboto">
      <PageBanner title="Careers" breadcrumb="Careers" backgroundImage={CareerBannerImage} />

      <div className="text-center py-12 px-4 md:px-20 ">
        <h2 className="text-2xl md:text-3xl font-bold text-[#2584C6] mb-4" data-aos="fade-up">
          Build, Innovate, and Grow Your Career at ESMOB Technologies
        </h2>
        <h3 className="text-lg md:text-xl text-gray-700 font-medium" data-aos="fade-up" data-aos-delay="200">
          Work with Purpose. Grow with Us.
        </h3>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start mb-20 px-4 md:px-20 shadow-lg bg-gray-100 py-10">
        <div className="lg:order-2 flex flex-col   w-full">
          <div data-aos="fade-right" className="flex flex-col items-center">
            <img src={careerImage} alt="Careers" className="rounded-xl shadow-lg w-full  object-cover" />
          </div>
         
        </div>

        <div
          className="text-gray-700 text-sm md:text-base xl:text-lg leading-relaxed lg:order-1 space-y-2 justify-text"
          data-aos="fade-left"
        >
          <p>
            At ESMOB Technologies, we believe that innovation begins with people. We're a team of thinkers, creators,
            and problem-solvers committed to building impactful technology solutions that shape the future. Since 2013,
            we've helped startups, enterprises, and government organizations succeed through cutting-edge software, AI,
            IoT, and cloud technologies.
          </p>
          <p>
            We’re always looking for passionate individuals who thrive in a collaborative environment and are driven by
            curiosity, creativity, and continuous learning. Whether you're a developer, designer, engineer, or
            strategist, your work here will matter.
          </p>
          <p>
            We offer more than just a job—we provide a platform for growth. From hands-on projects and mentorship to
            learning opportunities and career development, we support your journey every step of the way.
          </p>
          <p>
            Join us to work on exciting real-world challenges, explore new technologies, and make a difference with a
            team that values innovation, integrity, and impact.
          </p>

          <div
            className="max-w-sm py-12 text-center border-l-4 border-[#F7941D] bg-gray-50 p-6 md:p-8 shadow-md rounded-lg mx-auto"
            data-aos="zoom-in-up"
          >
            <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2">Please send your resumes</h3>
            <a
              href="mailto:hr@esmobtechnologies.com"
              className="text-[#2584C6] font-semibold text-base md:text-lg hover:underline break-all"
            >
              hr@esmobtechnologies.com
            </a>
          </div>
        </div>
        
      </div>
    </div>
    )}
    </>
  );
};

export default Careers;
